import { Controller } from "stimulus";
import hideElement from "../../functions/hideElement";
import showElement from "../../functions/showElement";

export default class extends Controller {
  static get targets() {
    return ["notification", "message"];
  }

  connect() {
    hideElement(this.notificationTarget);
    this.queue = this.initialMessages;
    this.displayFirstMessage();
    this.bindEvents();
  }

  disconnect() {
    this.unbindEvents();
  }

  bindEvents() {
    this.addNotificationHandler = this.addNotificationToQueue.bind(this);
    document.addEventListener("notification:add", this.addNotificationHandler);
  }

  unbindEvents() {
    document.removeEventListener(
      "notification:add",
      this.addNotificationHandler,
    );
  }

  addNotificationToQueue(event) {
    if (event.detail && event.detail.message) {
      this.queue.push(event.detail.message);
      this.displayFirstMessage();
    }
  }

  displayFirstMessage() {
    if (this.currentMessage || this.queue.length === 0) {
      return;
    }

    this.currentMessage = this.queue.shift();
    this.messageTarget.textContent = this.currentMessage;
    showElement(this.notificationTarget);
    setTimeout(this.clearMessage.bind(this), this.displayTimeMilliSeconds);
  }

  clearMessage() {
    hideElement(this.notificationTarget);
    this.messageTarget.textContent = "";
    this.currentMessage = null;
    this.displayFirstMessage();
  }

  get displayTimeMilliSeconds() {
    return 5000;
  }

  get initialMessages() {
    if (this.element.dataset.initialMessages === "") {
      return [];
    }

    return this.element.dataset.initialMessages.split(",");
  }
}
